import { Link } from "react-router-dom";
import { useSeo } from "@/lib/seo";

export default function NotFound() {
  useSeo({ title: "Page introuvable | Termite Habitat", description: "Cette page n'existe pas.", path: "/404", noindex: true });
  return (
    <section className="container-x py-28 text-center" data-testid="not-found-page">
      <p className="font-display text-8xl font-black text-[#C06014]">404</p>
      <h1 className="mt-4 text-3xl font-black">Les termites ont mangé cette page…</h1>
      <p className="mt-3 text-muted-foreground">Elle n'existe pas ou a été déplacée.</p>
      <Link to="/" className="btn-lift mt-8 inline-block rounded-full bg-[#C06014] px-6 py-3 font-bold text-white" data-testid="not-found-home-link">Retour à l'accueil</Link>
    </section>
  );
}
